module.exports = __webpack_public_path__ + "img/image_3_2.50f9fe20.jpg";